import { Component } from '@angular/core';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { SelectModule } from 'primeng/select';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'pm-form-field-select',
  imports: [ReactiveFormsModule, SelectModule],
  templateUrl: './pm-form-field-select.component.html',
  styleUrl: './pm-form-field-select.component.scss',
})
export class PmFormFieldSelectComponent extends FormFieldComponent {}
